<script>
    import { layoutMethods, eloadB2BMethods, eloadB2BComputed } from "@/state/helpers";
    import { getModuleAccess } from '@/router/helper.js'
    import b2bAction from '@/views/pages/eloadB2B/action.vue';
    import Swal from "sweetalert2";

    /**
     * Eload b2b details component
     */
    export default {
        page: {
        title: "eLoad B2B Details"
        },
        components: {
            b2bAction,
        },
        computed: {
            ...eloadB2BComputed,
            requestStatus: {
                get(){
                    let status = "Requesting",
                        cs = "text-warning";
                    switch (this.eloadB2BRequestDetails?.status) {
                        case "approved":
                            status = "Approved"
                            cs = "text-success"
                            break;
                        case "rejected":
                            status = "Rejected"
                            cs = "text-danger"
                            break;
                    
                        default:
                            break;
                    }
                    return {status,cs}
                },
                // set(){
                    
                // }
            }
        },
        data() {
            return {
                title: "eLoad B2B Details",
                refNo:null,
                userAccess: {
                    access: {
                        create: false,
                        read: false,
                        update: false,
                        delete: false,
                    }
                },
                isLightboxVisible: false,
                lightBoxImageUrl: "",
            };
        },
        methods: {
            ...layoutMethods,
            ...eloadB2BMethods,
            async fetchRequestDetails(){
                await this.getEloadB2BRequestDetails({
                    refNo: this.refNo
                });
                if(this.$options.filters.isEmpty(this.eloadB2BRequestDetails)){
                    Swal.fire("Request not found!", `You are viewing the details of a request that does not exist`, "warning");
                    this.backTo();
                }
            },
            backTo(){
                this.$router.push(
                    this.$route.query.redirectFrom || {
                        name: "Eload B2B Requests"
                    }
                );
            },
            viewImage(img){
                this.lightBoxImageUrl = img
                this.isLightboxVisible = true;
            }
        },
        async mounted(){
            this.clearRequestDetails();
            this.changeTitle({ title: "Eload B2B Request Details" });
            this.changeBreadCrumb({
            breadCrumbs: [
                { text: "Peddlr", to: { name: "Home" } },
                { text: "eLoad B2B", to: { name: "" } },
                { text: "Request", to: { name: "Eload B2B Requests" } },
                { text: "Details", to: { name: "Eload B2B Request details" } },
            ],
            });
            this.refNo = this.$route.params.refNo;
            await getModuleAccess('Products', 'eLoad B2B', 'Request')
            .then((access) => this.userAccess.access = access);
            await this.fetchRequestDetails();
        }
    }
    
</script>
<style scoped>
    ul {list-style-type: none;} 
    ul li {margin: 10px 0px;}
    .custom-image-container{
        width: 60pt;  
        height: 30px; 
        overflow: hidden; 
        border: 1px solid #999;
        border-radius: 8px;
    }
    .custom-image-container img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* This prevents stretching */
    }
</style>
<template>
  <div class="row"><!-- outer div-->
    <vue-easy-lightbox
        moveDisabled
        :visible="isLightboxVisible"
        :imgs="lightBoxImageUrl"
        @hide="isLightboxVisible = false"
    ></vue-easy-lightbox>
    <b-col sm="12" md="4">
        <b-card>
            <h4 class="border-bottom" @click="fetchRequestDetails()">Merchant Details</h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Request ID:</span> {{ eloadB2BRequestDetails.id  | notEmpty | addPadding }}
                </li>
                <li>
                    <span class="fw-semibold">Request Date:</span> {{ eloadB2BRequestDetails.created_at | formatDate }}
                </li>
                <li>
                    <span class="fw-semibold">User ID:</span> {{ eloadB2BRequestDetails.user_id | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Business Name:</span> {{ eloadB2BRequestDetails.businessName | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Merchant Name:</span> {{ eloadB2BRequestDetails.merchantName | notEmpty}} 
                </li>
            </ul>
            <h4 class="border-bottom mt-4">{{ eloadB2BRequestDetails.status == "rejected" ? "Rejection":"Approval"}} Details</h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Requested By:</span> {{ eloadB2BRequestDetails.requested_by | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">{{ eloadB2BRequestDetails.status == "rejected" ? "Rejected":"Approved"}} By Finance:</span> {{ eloadB2BRequestDetails.approved_by | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">{{ eloadB2BRequestDetails.status == "rejected" ? "Rejected":"Approved"}} Date:</span> {{ eloadB2BRequestDetails.approved_at | formatDate  | notEmpty}}
                </li>
            </ul>
        </b-card>
    </b-col>
    <b-col sm="12" md="8">
        <b-card>
            <h4 class="border-bottom">Payment Details</h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Payment Reference Number:</span> {{ eloadB2BRequestDetails.reference_number | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Deposit Date:</span> {{ eloadB2BRequestDetails.deposit_date | formatDateOnly}}
                </li>
                <li>
                    <span class="fw-semibold">Sender Bank:</span> {{ eloadB2BRequestDetails.sender_bank_name | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Peddlr Bank Acount:</span> {{ eloadB2BRequestDetails.peddlr_bank_name | notEmpty}}
                </li>
                <li class="d-flex align-items-center">
                    <span class="fw-semibold me-2">Deposit Screenshot:</span> 
                    <div class="custom-image-container" v-if="eloadB2BRequestDetails?.deposit_ss_url">
                        <img 
                        :src="eloadB2BRequestDetails.deposit_ss_url" 
                        @click="viewImage(eloadB2BRequestDetails.deposit_ss_url)" 
                        alt="Deposit Screenshot" 
                        class="ms-2 c-pointer"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        >
                    </div>
                </li>
                <li>
                    <span class="fw-semibold">Amount Paid:</span> PHP {{ eloadB2BRequestDetails.paid_amount | numberWithCommas }}
                </li>
                <li>
                    <span class="fw-semibold">Default Rebate:</span> {{ eloadB2BRequestDetails.rebate_percentage | notEmpty}}%
                </li>
                <li>
                    <span class="fw-semibold">Topup Amount:</span> PHP {{ eloadB2BRequestDetails.topup_amount | numberWithCommas }}
                </li>
                <li>
                    <span class="fw-semibold">Status:</span> <span :class="requestStatus.cs">{{ requestStatus.status }}</span>
                </li>
                <li class="d-flex align-items-center">
                    <span class="fw-semibold me-2">Remarks:</span> 
                    <div v-if="eloadB2BRequestDetails.status == 'approved'" class="custom-image-container">
                        <img 
                        :src="eloadB2BRequestDetails.remarks" 
                        @click="viewImage(eloadB2BRequestDetails.remarks)" 
                        alt="Proof of confirmation" 
                        class="ms-2 c-pointer"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        >
                    </div> 
                    <div v-else>
                        {{ eloadB2BRequestDetails.remarks | notEmpty }}
                    </div>
                </li>
            </ul>

            <b2b-action
               view = "details"
               :requestData = eloadB2BRequestDetails
               :userAccess = userAccess.access
               @reload = "fetchRequestDetails()"
            />

            <div class="text-end">
                <b-button variant="light" @click="backTo">Close</b-button>
            </div>
        </b-card>
    </b-col>
  </div> <!-- end of outer div-->
</template>
<!-- 
{{ view }}
{{ requestData }} -->